import React, { useState, useEffect } from 'react';
import { ShieldCheck, X } from 'lucide-react';

const AgeGate = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem('cb_age_ok');
    if (!ok) setOpen(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cb_age_ok', '1');
    setOpen(false);
  };

  const deny = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm px-4">
      <div className="relative w-full max-w-md cb-panel border border-[#a6e22e]/30 rounded-2xl p-8 text-center cb-fade-up smoke-red">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full border-2 border-[#a6e22e] text-[#a6e22e] glow-pulse">
          <ShieldCheck size={30} />
        </div>
        <div className="font-bangers text-4xl mb-1">
          <span className="graffiti-gradient">Masz ukończone 18 lat?</span>
        </div>
        <p className="text-white/70 text-sm mb-6 mt-3">
          Ta strona zawiera produkty przeznaczone wyłącznie dla osób pełnoletnich. Potwierdź swój wiek, aby kontynuować.
        </p>
        <div className="flex gap-3">
          <button onClick={accept} className="btn-green flex-1 py-3 px-4">TAK, mam 18+</button>
          <button onClick={deny} className="btn-ghost-red flex-1 py-3 px-4 inline-flex items-center justify-center gap-1"><X size={16}/> Nie</button>
        </div>
        <p className="text-white/30 text-[11px] mt-5">Wchodząc akceptujesz regulamin i politykę prywatności.</p>
      </div>
    </div>
  );
};

export default AgeGate;
